// Routes — owned by the stack navigation shell (see src/pages/SHELL.md).
// Commit before `appfactory spec apply`: it rewrites this file.

import { createRouter, createMemoryHistory } from '@ionic/vue-router';
import { peopleOutline, hardwareChipOutline, settingsOutline, radioOutline } from 'ionicons/icons';

import StackShell from './pages/StackShell.vue';
import { PRODUCT_ROUTES } from './product-routes.js';

/** Where the app opens. main.js pushes this. */
export const HOME = '/tabs/pager';

const ICONS = { pager: radioOutline, friends: peopleOutline, devices: hardwareChipOutline, settings: settingsOutline };

// The top-level screens. A stack shell draws no chrome from this list; the
// Pager screen's header links to the others.
export const DESTINATIONS = PRODUCT_ROUTES
  .filter((r) => r.primary || r.destination)
  .map((r) => ({ name: r.id, label: r.label, path: r.path, icon: ICONS[r.id] }));

export const TABS = DESTINATIONS;

export default createRouter({
  history: createMemoryHistory(),
  routes: [
    { path: '/', redirect: HOME },
    {
      path: '/tabs/',
      component: StackShell,
      children: [
        { path: '', redirect: HOME },
        ...PRODUCT_ROUTES.map((r) => ({
          path: r.path.replace(/^\/tabs\//, ''),
          name: r.id,
          component: r.component,
          props: true,
        })),
      ],
    },
  ],
});
